export const SET_COMPANY = 'company/setCompany'
export const SET_MEMBERS = 'company/setMember'
export const SET_CURRENCIES = 'company/setCurrencies'
export const SET_TENANT = 'company/setTenant'

export const SAVE_MEMBER = 'company/saveMember'

export const DESTROY_MEMBER = 'company/destroyMember'

export const CLEAR_STATE = 'company/clearState'



// WEBPACK FOOTER //
// ./src/modules/company/store/mutations_types.js